import React from 'react';
import { Heading } from '@chakra-ui/react';
import './styles/section-heading.css';

/**
 * Section title in the instrument-panel idiom: a mono index, the title, then a
 * hairline running to the edge. Used by every section so they read as one set.
 */
export default function SectionHeading({ index, children }) {
  return (
    <div className="section-heading">
      <span className="section-heading__index">{index}</span>
      <Heading className="section-heading__title" size="lg">
        {children}
      </Heading>
      <span className="section-heading__rule" aria-hidden="true" />
    </div>
  );
}
